export default {
    animal_hazard: {
        name: "Animal Hazard",
        url: "sarcop_hazards/animal_hazard",
    },
    fire_incident: {
        name: "Fire Incident",
        url: "sarcop_hazards/fire_incident",
    },
    flood_water_level: {
        name: "Flood Water Level",
        url: "sarcop_hazards/flood_water_level",
    },
    hazardous_material_incident: {
        name: "Hazardous Material Incident",
        url: "sarcop_hazards/hazardous_material_incident",
    },
    other_hazard: {
        name: "Other Hazard",
        url: "sarcop_hazards/other_hazard",
    },
    route_blocked: {
        name: "Route Blocked",
        url: "sarcop_hazards/route_blocked",
    },
}
